/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_PERMISSION,
  LOAD_PERMISSION_SUCCESS,
  LOAD_PERMISSION_ERROR,
  UPDATE_PERMISSION_LIST,
  UPDATE_PERMISSION_LIST_SUCCESS,
  UPDATE_PERMISSION_LIST_ERROR,
  UPDATE_LPND_STATUS,
  UPDATE_LPND_STATUS_SUCCESS,
  UPDATE_LPND_STATUS_ERROR,
  DELETE_RECORD,
  DELETE_RECORD_ERROR,
  DELETE_RECORD_SUCCESS,
  APPLY_PERMISSION_DETAILS,
  APPLY_PERMISSION_DETAILS_SUCCESS,
  APPLY_PERMISSION_DETAILS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(permissionMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    permissionMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list, success) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
    success,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}
//permission list
export function loadPermission(searchvalue) {
  return {
    type: LOAD_PERMISSION,
    searchvalue,
  }
}
export function loadPermissionsuccess(permission_details) {
  return {
    type: LOAD_PERMISSION_SUCCESS,
    permission_details,
  }
}
export function loadPermissionerror(error) {
  return {
    type: LOAD_PERMISSION_ERROR,
    error,
  }
}

//Permission list Update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updatePermissionList(permissionDetails) {
  return {
    type: UPDATE_PERMISSION_LIST,
    permissionDetails,
  }
}

export function updatePermissionListSuccess(permissionDetails, success) {
  return {
    type: UPDATE_PERMISSION_LIST_SUCCESS,
    permissionDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function updatePermissionListError(error) {
  return {
    type: UPDATE_PERMISSION_LIST_ERROR,
    error,
  }
}

//LPND status Update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateLpndStatus(statusDetails) {
  return {
    type: UPDATE_LPND_STATUS,
    statusDetails,
  }
}

export function updateLpndStatusSuccess(statusDetails, success) {
  return {
    type: UPDATE_LPND_STATUS_SUCCESS,
    statusDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateLpndStatusError(error) {
  return {
    type: UPDATE_LPND_STATUS_ERROR,
    error,
  }
}

export function deleteRecord(permissionData) {
  return {
    type: DELETE_RECORD,
    permissionData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteRecordSuccess(permissionData, success) {
  return {
    type: DELETE_RECORD_SUCCESS,
    permissionData,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteRecordError(error) {
  return {
    type: DELETE_RECORD_ERROR,
    error,
  }
}

//Apply Permission details
/**
 *
 * @param {integer} id
 * @returns
 */
export function applyPermissionList(applyPermissionDetails) {
  return {
    type: APPLY_PERMISSION_DETAILS,
    applyPermissionDetails,
  }
}

export function applyPermissionListSuccess(applyPermissionDetails, success) {
  return {
    type: APPLY_PERMISSION_DETAILS_SUCCESS,
    applyPermissionDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function applyPermissionListError(error) {
  return {
    type: APPLY_PERMISSION_DETAILS_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  loadPermission,
  loadPermissionsuccess,
  loadPermissionerror,

  updatePermissionList,
  updatePermissionListSuccess,
  updatePermissionListError,

  updateLpndStatus,
  updateLpndStatusSuccess,
  updateLpndStatusError,

  deleteRecord,
  deleteRecordSuccess,
  deleteRecordError,

  applyPermissionList,
  applyPermissionListSuccess,
  applyPermissionListError,
}

export default actions
